import styled from "styled-components";

export const ExerciseListAnswerCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
